import axios from 'axios'
import * as base from '@/api/endpoint/base'

export const getRequest = (url:string, json: any) => {
    const resp = axios({
        method: 'get',
        url: `${base.BaseWarehouse()}${url}` + base.getDefault(json), // ..,
        headers: {
            'Authorization': `Bearer ${base.token()}`
        }
    }).then((response) => {
        return response.data
    })
    return resp
}

export const getDownload = (url: string, json: any) => {
    const resp = axios({
        method: 'get',
        url: `${base.BaseWarehouse()}${url}` + base.getDefault(json), // ..,
        responseType: "arraybuffer",
        headers: {
            'Authorization': `Bearer ${base.token()}`,
            "Accept": "application/octet-stream",
        }
    }).then((response) => {
        return response.data
    })
    return resp
}

export const postRequest = (url:string, json: any) => {
    const resp = axios({
        method: 'post',
        url: `${base.BaseWarehouse()}${url}`,
        headers: {
            'Authorization': `Bearer ${base.token()}`
        },
        data: json
    }).then((response) => {
        return response.data
    })
    return resp
}





